(function (angular) {
  var controllerId = "signUpController";
  angular
    .module("app")
    .controller(controllerId, ["$scope", "_", "STATES", "signupService", "$window", "$timeout", "$location", "alkAuthenticationService", "Messages", "ALKLogin", "eventTracker","pcmtidLoginService",
      function ($scope, _, STATES, signupService, $window, $timeout, $location, alkAuthenticationService, Messages, ALKLogin, eventTracker,pcmtidLoginService) {
        eventTracker.track("Sign Up - Form Loaded");
        var vm = this;
        vm.isAlertShowing = false;
        vm.alertMessage = "";
        vm.title = "signUpController";
        vm.states = STATES;
        vm.countries = _.uniq(STATES, "country");
        vm.wizardStep = 1;
        vm.userAccounts = [];
        vm.enterNewAccount = false; // use existing account if available
        vm.canUserSignupForTrial = true;
        vm.trimbleCloudUrl = pcmtidLoginService.getTrimbleCloudUrl();
        vm.clientId = pcmtidLoginService.getClientId();
        vm.tidApplicationName = pcmtidLoginService.getTidApplicationName();
        vm.searchObject = $location.search();
        vm.invalidToken = false;
        var redirectUrl =   `${pcmtidLoginService.baseUrl()  }/signup?featureLevel=${vm.searchObject.featureLevel}`;
        if (vm.searchObject.featureLevel !== undefined) {
          eventTracker.track(`Sign Up - ${vm.searchObject.featureLevel} Clicked`); // Premium, Trial
        }
        var InitialSignup = {
          city: "",
          state: "",
          country: "",
          featureLevel: "Premium", // default feature is Trial
          price: "Free",
          isCreditCardRequired: function () {
            return this.featureLevel !== "Trial";
          },
          userExists: false, // start off with the empty form, the user does not exist.
          numberOfUsers: 1,
          newPlusAccount: false,
          card: {},
          numberOfTrucks: 0
        };
        vm.signup = angular.copy(InitialSignup);
        var numProcessing = 0;

        var startProcessing = function () {
          numProcessing++;
          vm.isProcessing = true;
        };

        var stopProcessing = function () {
          numProcessing--;

          if (numProcessing < 0) {
            numProcessing = 0;
          }

          if (numProcessing === 0) {
            vm.isProcessing = false;
          }
        };
        var scrollToTop = function () {
          $window.scrollTo(0, 0);
        };
        var onError = function (errorObj) {
          if (errorObj === null) {
            Messages.add("danger", "Unknown error.", {
              showOnNextPage: false
            });
            scrollToTop();
            return;
          }
          var message = errorObj.ExceptionMessage || errorObj.Message;

          if (errorObj.ModelState != null) {
            for (var property in errorObj.ModelState) {
              if (property.indexOf(".") > 0 && errorObj.ModelState.hasOwnProperty(property) && _.isArray(errorObj.ModelState[property])) {
              // do stuff
                _.each(errorObj.ModelState[property], (validationMessage) => {
                  Messages.add("danger", validationMessage, {
                    showOnNextPage: false
                  });
                }); // jshint ignore:line
              }
              else {
                Messages.add("danger", (errorObj.ExceptionMessage || errorObj.Message), {
                  showOnNextPage: false
                });
              }
            }
          } else if (message != null) {
            Messages.add("danger", (errorObj.ExceptionMessage || errorObj.Message), {
              showOnNextPage: false
            });
          } else if (typeof errorObj === "string") {
            Messages.add("danger", errorObj, {
              showOnNextPage: false
            });
          } else {
            Messages.add("danger", "Unknown error.", {
              showOnNextPage: false
            });
          }
          vm.isProcessing = false;
          scrollToTop();
        }
        var callService = function (func, setProcessing) {
          if (setProcessing === null) {
            setProcessing = true;
          }

          if (setProcessing) {
            startProcessing();
          }

          var resp = func();
          resp.error(onError);

          if (setProcessing) {
            resp["finally"](stopProcessing);
          }

          return resp;
        };

        $scope.gettidAccounts = function(code,tAccount,rUrl) {
          vm.isProcessing = true;
          pcmtidLoginService.tidlogin(vm.searchObject.code,tAccount,rUrl).then((resp) => {
            vm.isProcessing = false;
            vm.signup.firstName =  resp.firstName;
            vm.signup.lastName =  resp.lastName;
            // console.log(resp.accountName);
            var acc = {accountId:resp.accountId,accountName:resp.account};
            // vm.wizardStep = 4;
            if (tAccount === null)
            {
              vm.userAccounts = [];
              vm.userAccounts.push(acc);
              vm.canUserSignupForTrial = signupService.canUserSignupForTrial(vm.userAccounts);
              if (vm.canUserSignupForTrial === false && vm.signup.featureLevel === "Trial") {
                vm.signup.featureLevel = "Premium";
              }

              // if there are no accounts with this user, just display the regular form
              vm.wizardStep = (vm.userAccounts.length > 0) ? 3 : 4;
            }

          }, (error) => {
            switch (error.status) {
              case "FailedToLoginDueToMultipleAccounts": {
                var accounts = error.accounts;
                vm.userAccounts = [];


                for (var i = 0; i < accounts.length; i++) {
                  vm.userAccounts.push(accounts[i]);
                }

                vm.canUserSignupForTrial = signupService.canUserSignupForTrial(accounts);
                if (vm.canUserSignupForTrial === false && vm.signup.featureLevel === "Trial") {
                  vm.signup.featureLevel = "Premium";
                }

                // if there are no accounts with this user, just display the regular form
                vm.wizardStep = (accounts.length > 0) ? 3 : 4;
               var enabledAccount= _.find(accounts, function (account) {
                  return account.userState === "Enabled" && account.accountState === 1;
                });
                if(enabledAccount){
                $scope.gettidAccounts(code,enabledAccount.accountName,rUrl);
                }else{
                  vm.isProcessing = false;
                }
                break;
              }

              case "NoAccess": {
                vm.wizardStep = 4;
                vm.isProcessing = false;
                break;
              }
              case  "NotExist": {
                vm.wizardStep = 4;
                vm.isProcessing = false;
                break;
              }
              case "UserDisabled": {
                vm.isProcessing = false;
                break;
              }

              case "FailedToLoginAccountExpired": {
                if (error.userInfo !== null) {
                  vm.isProcessing = false;
                  var userInfo = error.userInfo;
                  var expiredAccount = {accountName:userInfo.accountName,accountId:userInfo.accountId}
                  if (vm.userAccounts.length === 0) {
                    vm.userAccounts.push(expiredAccount)
                  }
                  vm.signup.firstName =  userInfo.firstName;
                  vm.signup.lastName =  userInfo.lastName;
                  vm.wizardStep = (vm.userAccounts.length > 0) ? 3 : 4;
                  break;
                }
                break;
              }
              case "FailedToValidateTrimbleIdentityToken": {
                vm.invalidToken = true;
                vm.isProcessing = false;
                break;
              }

              case "AccountDisabled": {
                vm.isProcessing = false;
                $scope.gettidAccounts(code,vm.userAccounts[1].accountName,rUrl);
                break;
              }
              default: {
                vm.wizardStep = 4;
                vm.isProcessing = false;
              }
            }

          });
        }

        var account = null;

        if (vm.searchObject.state) {
          vm.signup.userName = vm.searchObject.state;
          if (vm.searchObject.ssoUser === "true") {

            $scope.gettidAccounts(vm.searchObject.code,null,redirectUrl);

          } else {
            vm.wizardStep = 4;
          }

        }


        var updatePrice = function () {
          if (!vm.signup.isCreditCardRequired()) {
            vm.signup.numberOfUsers = 1;
            vm.signup.price = 0;
          } else if (vm.signup.featureLevel === "Standard") {
            vm.signup.price = (59.99 * vm.signup.numberOfUsers);
          } else {
          // premium
            vm.signup.price = (84.99 * vm.signup.numberOfUsers);
          }
        };

        // wizard step 1 - check if the username exists
        var checkUserNameExists = function (sendEmail) {
        // before making any calls, ensure to log out so we don't send old credentials.
          alkAuthenticationService.logout();

          // checks to see if the user exists.
          var onSuccess = function (userExistsResponse) {
            vm.signup.userExists = userExistsResponse.Exists;

            vm.signup.confirmPassword = "";

            // step 2 is user verification - for new users that is with an emailed token, and existing users that is with the password
            vm.wizardStep = 2;
            if (userExistsResponse.Exists === true) {
              eventTracker.track("Sign Up - Existing Email Address");
            } else {
              eventTracker.track("Sign Up - New Email Address");
            }
            // if the user is new, send them a verification token
            if (userExistsResponse.Exists === false && sendEmail === true) {

              if (vm.signup.userName.indexOf("+") > -1)
              {
                vm.signup.newPlusAccount = true;
              }

              else {
                pcmtidLoginService.checkTidEmail(vm.signup.userName).then((data) => {
                  if (data.migrated) {
                    var url = pcmtidLoginService.goToTidSignin(vm.signup.userName,redirectUrl,false);
                    window.location.href = url;
                  } else {
                    var createUrl = pcmtidLoginService.goToTidSignup(vm.signup.userName,redirectUrl,false);
                    window.location.href = createUrl;
                  }

                }, (error) => {});

                // else
                // {
                //     signupService.sendVerification(vm.signup.userName, $location.search().featureLevel);
                // }
              }
            }

            // for both, new user signup, and validating user password, the next field is #password, so focus that
            $timeout(() => {
              if (vm.signup.userExists) {

                pcmtidLoginService.checkTidEmail(vm.signup.userName).then((data) => {
                  if (data.migrated) {
                    var url = pcmtidLoginService.goToTidSignin(vm.signup.userName,redirectUrl,true);
                    window.location.href = url;
                  } else {
                    var createUrl = pcmtidLoginService.goToTidSignup(vm.signup.userName,redirectUrl,true);
                    window.location.href = createUrl;
                  }

                }, (error) => {});
                $("#password").focus(); // jshint ignore:line
              }
            });
          };

          var resp = callService(() => {

            return signupService.userExists(vm.signup.userName);
          });

          resp.success(onSuccess);
        };

        // wizard step 2 - this step only needed if the username does exist. This step verifies the users username/password.
        var validateExistingUserPassword = function () {
        // validate password,
        // if it is not valid, show validation error.
        // if it is valid, display all the accounts for that user and

          // not logging into the application here, only validating username, password.
          var login = new ALKLogin(vm.signup.userName, vm.signup.password);
          alkAuthenticationService.validate(login)
            .then(() => {
              var getUserResponse = callService(() => {
                return signupService.getUser(vm.signup.userName);
              });

              getUserResponse.success((foundUser) => {
                vm.signup.firstName = foundUser.firstName;
                vm.signup.lastName = foundUser.lastName;
              });

              var accountsResponse = callService(() => {
                return signupService.getAccounts(vm.signup.userName);
              });

              accountsResponse.success((accounts) => {
                vm.userAccounts = [];

                for (var i = 0; i < accounts.length; i++) {
                  vm.userAccounts.push(accounts[i]);
                }

                vm.canUserSignupForTrial = signupService.canUserSignupForTrial(accounts);
                if (vm.canUserSignupForTrial === false && vm.signup.featureLevel === "Trial") {
                  vm.signup.featureLevel = "Premium";
                }

                // if there are no accounts with this user, just display the regular form
                vm.wizardStep = (accounts.length > 0) ? 3 : 4;
              });
            }, () => {
              Messages.add("danger", "Invalid username or password", {
                showOnNextPage: false
              });
              vm.isProcessing = false;
            });
        };

        // wizard step 3 - make sure this company is not associated with pcm already and make sure the name does not already exist.
        var validateCompany = function () {
          vm.wizardStep = 4;
        };

        // wizard step 4 - submits the form
        var signupUser = function () {

          var onSuccess = function () {

            vm.isAlertShowing = true;
            vm.alertMessage = "You have successfully signed up.";
            if (vm.searchObject.ssoUser !== "true") {
              $scope.gettidAccounts(vm.searchObject.code,null,redirectUrl);
            }
            $timeout(() => {

              vm.isAlertShowing = false;
              $location.url("/signupLogin");
            }, 1900);
            eventTracker.track(eventTracker.EVENTS.SIGNUP, { signup: vm.signup });
            $window.ga("send","event","SignupSubmitted", `${vm.signup.featureLevel  }Signup`, "success");
            eventTracker.track("Sign Up - Form Submitted");
          };

          var signupVm = vm.signup;
          vm.signup.password = "PCMPassword@1234";
          signupVm.CardHolderName = vm.signup.card.name;
          signupVm.CardType = vm.signup.card.type;
          signupVm.CardNumber = vm.signup.card.number;
          signupVm.ExpirationMonth = vm.signup.card.expMonth;
          signupVm.ExpirationYear = vm.signup.card.expYear;
          signupVm.CVV = vm.signup.card.cvv;

          var resp = callService(() => {
            vm.isProcessing = true;
            return signupService.createSelfServiceUser(signupVm);
          });

          // if the model is valid, submit it using the user service.
          resp.success(onSuccess);
        };

        // handle page load and query parameters.  This includes getting the 'verification email' token and the hyperlink and parameters. Also, if the user enters the page from the homepage and selects Trial
        if (vm.searchObject.featureLevel === "Trial" || vm.searchObject.featureLevel === "Premium" || vm.searchObject.featureLevel === "Standard") {
          vm.signup.featureLevel = vm.searchObject.featureLevel;
        }

        if (vm.searchObject.userName != null) {
          vm.signup.userName = vm.searchObject.userName;

          if (vm.searchObject.token != null) {
            vm.signup.verificationToken = vm.searchObject.token;
          }

          checkUserNameExists(false);
        }

        // Submit the form in its current state.  This displays all validaion errors on the current form and if the form is valid, performs the operation for the current step.
        vm.signUp = function () {
          Messages.clear();
          $scope.$broadcast("show-errors-check-validity");

          // console.log(vm.isProcessing);
          if (vm.wizardStep >= 4) {
            $scope.signUpForm.detailsForm.submitted = true;
          }

          if ($scope.signUpForm.$valid) {
            if (vm.wizardStep === 1) {
              checkUserNameExists(true);

            } else if (vm.wizardStep === 2) {

              if (vm.signup.userExists) {
                validateExistingUserPassword();
              } else {
                vm.wizardStep = 4;

                // after going to the next step, set the correct field to focus
                $timeout(() => {
                  $("#password").focus(); // jshint ignore:line
                });
              }

            } else if (vm.wizardStep === 3) {
              validateCompany();

            } else {

              signupUser();
            }
          } else {
            eventTracker.track("Sign Up - Form Invalid");
          }
        };

        vm.useNewAccount = function () {
        // console.log("use new account");

          // cleanup the model - account id is no longer being used
          delete vm.signup.accountId;
          delete vm.signup.companyName;
          delete vm.companyAdminEmail;
          delete vm.hdnAccountId;

          vm.enterNewAccount = true;

          $timeout(() => {
            $("#newCompanyName").focus(); // jshint ignore:line
          });
        };

        vm.useExistingAccount = function () {
        // cleanup the model - company name is no longer being used
          delete vm.signup.companyName;
          delete vm.companyAdminEmail;
          delete vm.hdnAccountId;

          vm.enterNewAccount = false;
        };

        vm.accountSelected = function (account) {
          if (account.AssociatedWithPCM) {
            return;
          }

          vm.signup.companyName = account.AccountName;
          vm.signup.accountId = account.AccountId;
          vm.hdnAccountId = account.AccountId;
        };

        vm.sendVerificationToken = function () {
          var resp = callService(() => {
            return signupService.sendVerification(vm.signup.userName, $location.search().featureLevel);
          }, false);

          resp.success(() => {
            vm.verificationEmailSent = true;
          });
        };

        vm.reset = function () {
        // vm.signup = angular.copy(InitialSignup);
          vm.signup = {
            city: "",
            state: "",
            country: "",
            featureLevel: $location.search().featureLevel, // default feature is Trial
            price: $location.search().featureLevel === "Premium" ? 84.99 :
              $location.search().featureLevel === "Standard" ? 59.99 : 0,
            isCreditCardRequired: function () {
              return this.featureLevel !== "Trial";
            },
            userExists: false, // start off with the empty form, the user does not exist.
            numberOfUsers: 1,
            newPlusAccount: false,
            card: {},
            numberOfTrucks: 0
          };

          $scope.$broadcast("show-errors-reset");

          vm.wizardStep = 1;
          vm.userAccounts = [];
          vm.canUserSignupForTrial = true;
          Messages.clear();

          vm.enterNewAccount = false; // use existing account if available
          vm.verificationEmailSent = false;
          delete vm.hdnAccountId;

          vm.invalidToken = false;

          $timeout(() => {
            $("#userName").focus(); // jshint ignore:line
          });
        };

        $scope.$watch("vm.signup.state", () => {
          if (vm.signup && vm.signup.state != null && vm.signup.state !== "") {
            var c = _.find(STATES, {
              abbreviation: vm.signup.state
            });
            if (c.country !== vm.signup.country) {
              vm.signup.country = c.country;
            }
          }
        });

        $scope.$watch("vm.signup.country", () => {
          if (vm.signup && vm.signup.state != null && vm.signup.state !== "") {
            var c = _.find(STATES, {
              abbreviation: vm.signup.state
            });
            if (c.country !== vm.signup.country) {
              vm.signup.state = "";
            }
          }
        });

        $scope.$watchGroup(["vm.signup.featureLevel", "vm.signup.numberOfUsers"], () => {
          updatePrice();

          if (vm.signup.featureLevel === "Trial") {
            vm.signup.card = {};
          }
        });
      }
    ]);
})(angular);



// WEBPACK FOOTER //
// ./app/account/signUp.controller.js